<template>
  <div >
    <vs-alert v-if="notif.msg"
    :active.sync="active1"
    closable
    close-icon="clear"
    class="text-center custom">
    {{notif.msg}}{{selLocalStorage}}
    </vs-alert>
    </div>
   </template>

<script>
import {GET_TOP_ANNOUNCENMENT} from '@/graphql'
export default {
  data () {
    return {
      active1:true,
      notif:{
        id:null,
        msg:null
      }
    }
  },
  computed:{
    selLocalStorage () {
      if (this.active1 === false) {
        localStorage.setItem('notify', this.notif.id)
      }
    }
  },
  created () {
    this.$apollo
      .query({
        query: GET_TOP_ANNOUNCENMENT
      })
      .then((response) => {
        console.log(response)
        if (response.data.topAnnouncements.id === localStorage.getItem('notify')) {
          this.notif.msg = null
          this.notif.id = null
        } else {
          this.notif.msg = response.data.topAnnouncements.message
          this.notif.id = response.data.topAnnouncements.id
        }
      })
      .catch((error) => {
      })
  }
}
</script>
<style>
.custom{
    z-index: 1000000;
  width: calc(100% - 260px);
    position: fixed;
    background-color: #007BFF;
    color:white;

}
/*    @media (max-width: 1400px) {*/
/*   .custom{*/
/*    width: 80%;*/
/*}*/

/*    }*/
/*@media (max-width: 1300px) {*/
/*   .custom{*/
/*    width: 80%;*/
/*}*/
/*    }*/
@media (max-width: 1200px) {
   .custom{
    width: 78%;
}
    }


.con-vs-alert-primary .con-x{
background:none !important;
}
</style>
